module.exports = __webpack_public_path__ + "img/bg-down-about-me.d7bb336e.svg";